import React, { FC, useState } from 'react'

import { Box, Button, Theme, Typography, useTheme } from '@mui/material'
import { t } from 'i18next'
import { isEqual } from 'lodash'

import { ReactComponent as CopyIconChecked } from '../../assets/icons/checked.svg'
import { ReactComponent as CopyIcon } from '../../assets/icons/copy.svg'
import { useCopy } from '../../pages/Dashboard/hooks'

import { CopyProps } from './types'

const copyButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  padding: 0,
  minWidth: '100%',
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '& svg': {
    width: (theme: Theme) => theme.spacing(2),
    height: 'auto',
  },
  '& p': {
    fontSize: (theme: Theme) => theme.spacing(1.5),
    lineHeight: 1,
    fontWeight: 600,
    marginLeft: 1,
    color: (theme: Theme) => theme.palette.text.secondary,
    textTransform: 'initial',
  },
}

const CopyText: FC<CopyProps> = (copyData) => {
  const { palette } = useTheme()
  const [copied, setCopied] = useState(false)
  const { copyText, title, showOnlyIcon = false } = copyData

  const { handleCopy: _handleCopy } = useCopy(copyText, t('copied'))

  const handleCopy = () => {
    _handleCopy()
    setCopied(true)
  }

  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      sx={{
        color: copied ? palette.green[400] : palette.text.secondary,
        cursor: copied ? 'default' : 'pointer',
      }}
    >
      {copied ? (
        <Button disableRipple disableElevation sx={copyButtonStyles}>
          <CopyIconChecked />
          <Typography variant="body1">{t('copied', 'Copied')}</Typography>
        </Button>
      ) : (
        <Button disableRipple disableElevation sx={copyButtonStyles} onClick={handleCopy}>
          <CopyIcon />
          <Typography variant="body1">
            {!showOnlyIcon && t(title.key, title.defaultValue)}
          </Typography>
        </Button>
      )}
    </Box>
  )
}

export default React.memo(CopyText, isEqual)
